var siteId = 222222;
export var pagesDefault = [{
  link: '/v3/site/',
  text: '建站',
  name: 'createSite'
}, {
  link: '//vote.kuaizhan.com/backend.html',
  text: '投票',
  name: 'vote'
}];
export var crumbDataDefault = [{
  link: '/v3/site/',
  name: 'site',
  text: '站点列表'
}, {
  link: '/developer/my-plugins',
  name: 'developer',
  text: '开放平台'
}, {
  link: '/v3/feedback/list',
  name: 'kzuniversity',
  text: '反馈中心'
}, {
  link: '/v3/homepage/pricing',
  name: 'update',
  text: '升级套餐'
}];
export var subPagesDefault = []; // map

export var funcManageSubPagesMap = {
  club: {
    link: "/backendv1/forum-list?site_id=".concat(siteId),
    text: '社区管理',
    desc: '配置社区属性，管理话题及会员'
  },
  shop: {
    link: "/shop-office/sites/".concat(siteId, "/shops-list"),
    text: '电商管理',
    desc: '添加店铺和管理商品订单'
  },
  article: {
    link: "/post/?site_id=".concat(siteId),
    text: '文章管理',
    desc: '添加和管理文章素材'
  },
  service: {
    link: "/clubservice/backend/clubservice-list?site_id=".concat(siteId),
    text: '服务管理',
    desc: '管理自己的本地服务'
  }
};
export var fakeMsgList = [{
  is_clicked: false,
  is_important: false,
  title: '一周运营手把手教你用快站建咸鱼APP',
  url: 'https://m.kuaizhan.com/clubpc/topics/WeRkFb9lnigQu5s4#!/comments/0',
  _id: {
    $id: 0
  }
}, {
  is_clicked: true,
  is_important: false,
  title: '【重要】关于评论实行“先审后发”策略的通知',
  url: 'https://m.kuaizhan.com/clubpc/topics/WeRkFb9lnigQu5s4#!/comments/0',
  _id: {
    $id: 1
  }
}, {
  is_clicked: false,
  is_important: true,
  title: '关于评论实行“先审后发”策略的通知',
  url: 'https://m.kuaizhan.com/clubpc/topics/WeRkFb9lnigQu5s4#!/comments/0',
  _id: {
    $id: 2
  }
}, {
  is_clicked: false,
  is_important: true,
  title: '关于评论实行“先审后发”策略的通知',
  url: '',
  content: '关于评论实行“先审后发”策略的通知',
  create_time: 1506508157,
  _id: {
    $id: 3
  }
}];